import { onError } from "@apollo/client/link/error";
import appEvents from "src/modules/10-app/events";
const handleInvalidTokenLink = onError(({ networkError, graphQLErrors }) => {
    if (networkError && networkError.statusCode === 401) {
        console.log('[LOGOUT] Received Response Status 401');
        appEvents.onLogout();
    }
    if (graphQLErrors && graphQLErrors.length > 0) {
        const unauthenticated = graphQLErrors.some(gqlError => gqlError.extensions?.code === 'UNAUTHENTICATED');
        if (unauthenticated) {
            console.warn('[LOGOUT] Error: UNAUTHENTICATED');
            appEvents.onLogout();
        }
    }
});
export default handleInvalidTokenLink;
